"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlCompileError = void 0;
const rc_js_util_1 = require("rc-js-util");
class GlCompileError extends rc_js_util_1.NestableError {
}
exports.GlCompileError = GlCompileError;
//# sourceMappingURL=gl-compile-error.js.map